import React, { useState, useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitPatient, { Search } from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as actions from "../../_redux/patientsActions";
import * as Yup from "yup";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import * as uiHelpers from "./PatientImmunizationsUIHelpers";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "../column-formatters";
// import * as patients from "../../Patients";
import {
  PatientImmunizationsUIPatient,
  usePatientImmunizationsUIContext,
} from "./PatientImmunizationsUIContext";
import { usePatientsUIContext } from "../../PatientsUIContext";

function PatientImmunizations({ history }) {
  const PatientImmunizationsUIEvents = {
    openDetailPatientImmunizationsPage: (id) => {
      history.push(`/patients/${id}/immunizations`);
    },
  };

  const patientImmunizationsUIContext = usePatientImmunizationsUIContext();

  const patientImmunizationsUIProps = useMemo(() => {
    return {
      ids: patientImmunizationsUIContext.ids,
      setIds: patientImmunizationsUIContext.setIds,
      queryParams: patientImmunizationsUIContext.queryParams,
      setQueryParams: patientImmunizationsUIContext.setQueryParams,
      openDetailPatientAppointmentTransactionPage:
        patientImmunizationsUIContext.openDetailPatientAppointmentTransactionPage,
    };
  }, [patientImmunizationsUIContext]);

  // Fields
  const [loading, setloading] = useState(false);
  const [pic, setPic] = useState("");
  const dispatch = useDispatch();
  const currentState = useSelector(
    (state) => state.patients.immunizations,
    shallowEqual
  );
  const patient = useSelector((state) => state.patients.patient, shallowEqual);

  useEffect(() => {
    // clear selections list
    patientImmunizationsUIProps.setIds([]);

    dispatch(
      actions.fetchPatientImmunizations(patient.id, patientImmunizationsUIProps)
    );
  }, [patientImmunizationsUIProps.queryParams, dispatch]);
  // Methods

  const { totalCount, entities, listLoading } = currentState;
  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PatientImmunizationNameFormatter,
    },
    {
      dataField: "date",
      text: "Input date",
      sort: true,
      sortCaret: sortCaret,
    },

    {
      dataField: "type",
      text: "Type",
      sort: true,
      sortCaret: sortCaret,
    },

    {
      dataField: "created_at",
      text: "Created Date",
      sort: true,
      sortCaret: sortCaret,
    },
    // {
    //   dataField: "action",
    //   text: "Actions",
    //   formatter: columnFormatters.ActionsColumnFormatter,
    //   formatExtraData: {
    //     openDetailImmunizationPage: patientImmunizationsUIProps.openDetailImmunizationPage,
    //     openEditProductPage: patientImmunizationsUIProps.openEditProductPage,
    //     openDeleteProductDialog: patientImmunizationsUIProps.openDeleteProductDialog,
    //   },
    //   classes: "text-right pr-0",
    //   headerClasses: "text-right pr-3",
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: patientImmunizationsUIProps.queryParams.pageSize,
    page: patientImmunizationsUIProps.queryParams.pageNumber,
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      // patientImmunizationsUIProps.openDetailPatientPage(row?.id)
    },
  };

  return (
    <>
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">
            Immunizations
          </h3>
          <span className="text-muted font-weight-bold font-size-sm mt-1">
            List of patient's immunizations
          </span>
        </div>
      </div>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  patientImmunizationsUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: patientImmunizationsUIProps.ids,
                  setIds: patientImmunizationsUIProps.setIds,
                })}
                rowEvents={rowEvents}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}

// export default connect(null, patients.actions)(PatientPersonaInformation);
export default PatientImmunizations;
